export default "__VITE_ASSET__BqZvjieV__"